import './EditableInput.css';
import EditableInput from './EditableInput';

export default EditableInput;
